import { Component } from '@verndale/core';
class GeolocationModal extends Component {
  setupDefaults() {
    this.dom = {
      close: this.$el.find('.modal-close a'),
      container: this.$el.find('.modal-container'),
      overlay: this.$el.find('.modal-overlay'),
      selectWrapper: this.$el.find('.custom-select-wrapper'),
      selectoptions: this.$el.find('.custom-options'),
      selectedValue: this.$el.find('.selected-value'),
      select: this.$el.find('custom-select'),
      loader: this.$el.find('.modal-loading'),
      geolocation: this.$el.find('.geolocation-modal')
    };
    this.loading = true;
    this.isHomePage = this.$el.data('isHomePage');
    this.cookieName = this.$el.data('cookieName');
    this.showModal = this.$el.data('showModal');
    this.currentLang = this.$el.data('currentLang');
    this.cookieVisitedName = `${this.cookieName}-visited`;
    this.cookieValue = localStorage.getItem(this.cookieName);
    this.cookieVisitedValue =
      parseInt(localStorage.getItem(this.cookieVisitedName)) || 0;

    localStorage.setItem(this.cookieVisitedName, this.cookieVisitedValue);

    if (this.isHomePage === false && this.showModal) {
      localStorage.setItem(this.cookieVisitedName, this.cookieVisitedValue + 1);
      this.open();
    }

    this.setCurrentLang();
  }

  addListeners() {
    this.dom.close.on('click', this.close.bind(this));
    this.dom.selectWrapper.on('click', this.toggleOptions.bind(this));
    this.dom.selectoptions.on('click', this.selectOptions.bind(this));
    this.dom.container.on('load', this.setLoading(this));
  }

  setLoading() {
    if (this.loading) {
      this.dom.loader[0].style.display = 'flex';
      this.dom.geolocation[0].style.display = 'none';
    } else {
      this.dom.geolocation[0].style.display = 'block';
      this.dom.loader[0].style.display = 'none';
    }
  }

  toggleOptions() {
    this.dom.selectoptions.toggleClass('hidden');
  }

  selectOptions(e) {
    this.dom.selectedValue[0].innerHTML = e.target.innerText;
    const hiddenOptions = document.querySelectorAll('.select-options');
    const link = document.querySelector('.redirect-anchor');

    hiddenOptions.forEach(option => {
      if (option.value === e.target.dataset.value) {
        $(option).attr('selected', true);
        this.dom.selectedValue[0].dataset.value = e.target.dataset.value;
        link.href = option.dataset.link;
      } else {
        $(option).attr('selected', false);
      }
    });
  }

  open() {
    if (this.cookieVisitedValue < 1) {
      this.dom.container.removeClass('hidden');
      this.dom.overlay.removeClass('hidden');
    }
  }

  close() {
    this.dom.container.addClass('hidden');
    this.dom.overlay.addClass('hidden');
    const script = document.createElement('script');
    script.setAttribute('id', 'Cookiebot');
    script.setAttribute('src', 'https://consent.cookiebot.com/uc.js');
    script.setAttribute('data-cbid', 'bfd87e60-53dc-4c50-a640-d82ff5c22b0c');
    script.setAttribute('data-blockingmode', 'auto');
    script.setAttribute('type', 'text/javascript');
    const gbCookie = document.cookie.match(/_gb=([^;]*)/);
    if (gbCookie && gbCookie.length > 1 && gbCookie[1]) {
      // eslint-disable-next-line no-undef
      const decodedValue = atob(gbCookie[1]);
      script.setAttribute('nonce', decodedValue);
    }
    document.head.appendChild(script);
  }

  setCurrentLang() {
    if (this.cookieBanner) {
      this.cookieBanner.style.display = 'none';
    }
    const hiddenOptions = document.querySelectorAll('.select-options');
    hiddenOptions.forEach(option => {
      if (this.currentLang === option.value) {
        $(option).attr('selected', true);

        this.dom.selectoptions[0].children.forEach(custOption => {
          if (custOption.dataset.value === this.currentLang) {
            this.dom.selectedValue[0].innerHTML = custOption.innerText;
            this.dom.selectedValue[0].dataset.value = custOption.dataset.value;
          }
        });
      }
    });
    this.loading = false;
  }
}

export default GeolocationModal;
